/**
* @public
*/
const HlsErrors = {
	// normal failures

	// provides informative errors which are not necessarily fatal, ie retries.
	WARNING						: 'WARNING',

	// error preventing LOAD state from being entered.
	LOAD_FAILED					: 'LOAD_FAILED',

	// error occurred while FETCHING, will prevent PLAYBACK
	FETCH_FAILED				: 'FETCH_FAILED',		// for example, if there were no variants to fetch.

	// error occurred during playback which will prevent playback.
	PLAYBACK_FAILED				: 'PLAYBACK_FAILED',

	// an error occurred either during WIRING or ATTACHING the media
	MEDIA_CONTROLLER_FAILED		: 'MEDIA_CONTROLLER_FAILED',

	// the media element threw an error.
	MEDIA_ELEMENT_FAILED		: 'MEDIA_ELEMENT_FAILED',

	/*
		This error generally occurs during PLAYBACK, when no new content can be output
		and thus the stream will end earlier than expected. You should still wait for the
		STREAM_ENDED event in order to display all the content which is available.
	*/
	STREAM_TIMEOUT				: 'STREAM_TIMEOUT',

	UNEXPECTED_ERROR			: 'UNEXPECTED_ERROR',

	INTERNAL_EXCEPTION			: 'INTERNAL_EXCEPTION',
};

export default HlsErrors;



// WEBPACK FOOTER //
// ./src/HlsErrors.js